/* Election Candidate client data model
 *
 * Angular Module: trackerbase-app.models.election-candidate
 * Injected Factory: ElectionCandidate
 *
 * Includes both stub and non-stub election candidates. TODO: handle this better.
 *
 */

import Assert from "tbAssert";

import makePropsEnumerable from "../utility/MakePropsEnumerable";

class ElectionCandidate {
    constructor(
        tTargetData, //object { isStub: T/F, data: (either a tracking target or a stub tracking target) }
        candidacyStart,
        candidacyEnd,
        TrackingTargetFactory
    )
    {
        Assert.StrictAssert(TrackingTargetFactory != null, "Assertion Failure: Missing or Invalid Tracking Target Factory Service Dependency");

        if (tTargetData.isStub === true) {
            if ((angular.isDefined(tTargetData.data.trackingTargetId)) &&
                (tTargetData.data.trackingTargetId != null) &&
                (Number.isFinite(tTargetData.data.trackingTargetId)))
            {
                this.candidate = { trackingTargetId: tTargetData.data.trackingTargetId };
                this.candidateIsStub = true;
            }
            else {
                throw new TypeError("Missing required tracking target id.");
            }
        }
        else {
            if ((angular.isUndefined(tTargetData.data)) || (tTargetData.data == null)) {
                throw new TypeError("Missing required tracking target id.");
            }

            this.candidateIsStub = true;
            try {
                this.candidate = TrackingTargetFactory.CopyTarget(tTargetData.data);
                this.candidateIsStub = false;
            }
            catch (ex) {
                if (ex instanceof TypeError) {
                    if ((angular.isDefined(tTargetData.data.trackingTargetId)) &&
                        (tTargetData.data.trackingTargetId != null) &&
                        (Number.isFinite(tTargetData.data.trackingTargetId)))
                    {
                        this.candidate = { trackingTargetId: tTargetData.data.trackingTargetId };
                        this.candidateIsStub = true;
                    }
                    else {
                        throw ex;
                    }
                }
                else {
                    throw ex;
                }
            }

        }

        let possibleCandidacyStart = null;
        if ((angular.isDefined(candidacyStart)) &&
            (candidacyStart != null) &&
            (angular.isDate(candidacyStart)))
        {
            possibleCandidacyStart = candidacyStart;
        }
        else {
            throw new TypeError("Candidacy Start is missing or invalid.");
        }

        let possibleCandidacyEnd = null;
        if ((angular.isDefined(candidacyEnd)) &&
            (candidacyEnd != null) &&
            (angular.isDate(candidacyEnd)))
        {
            possibleCandidacyEnd = candidacyEnd;
        }
        else {
            throw new TypeError("Candidacy End is missing or invalid.");
        }

        if (possibleCandidacyStart <= possibleCandidacyEnd) {
            this.candidacyStart = possibleCandidacyStart;
            this.candidacyEnd = possibleCandidacyEnd;
        }
        else {
            throw new TypeError("Candidacy Start is after Candidacy Start");
        }
    }

    toString() {
        return (this.candidateIsStub ? "(stub/" + String(this.candidate.trackingTargetId) + ")" : this.candidate.toString()) +
            "/" + this.candidacyStart.toString() +
            "/" + this.candidacyEnd.toString();
    }
    
    valueOf() {
        return this.candidate.trackingTargetId + (4322 * this.candidacyStart.valueOf()) + (410334 * this.candidacyEnd.valueOf());
    }
    
    get candidateId() {
        return this.candidate.trackingTargetId;
    }
    
    get candidacyStartDate() {
        return this.candidacyStart;
    }
    
    set candidacyStartDate(sDate) {
        if ((angular.isDefined(sDate)) &&
            (sDate != null) &&
            (angular.isDate(sDate)) &&
            (sDate <= this.candidacyEnd))
        {
            this.candidacyStart = new Date(sDate.getTime());
        }
    }
    
    get candidacyEndDate() {
        return this.candidacyEnd;
    }
    
    set candidacyEndDate(eDate) {
        if ((angular.isDefined(eDate)) &&
            (eDate != null) &&
            (angular.isDate(eDate)) &&
            (this.candidacyStart <= eDate))
        {
            this.candidacyEnd = new Date(eDate.getTime());
        }
    }

    addCandidateData(targetData, isFromFactory) {
        Assert.StrictAssert(isFromFactory, "Election Candidate's Add Candidate Data Method Has Been Moved To A Separate Election Candidate Factory");

        this.candidate = targetData;
        this.candidateIsStub = false;
    }

    wasCandidateOnDate(eventDate) {
        return ((this.startDate <= eventDate) &&
        (eventDate <= this.endDate));
    }


}

makePropsEnumerable(ElectionCandidate.prototype, [
    "candidateId",
    "candidacyStartDate",
    "candidacyEndDate",
    "addCandidateData",
    "wasCandidateOnDate"
]);

export default ElectionCandidate;


//////////////////
// WEBPACK FOOTER
// ./src/models/ElectionCandidate.js
// module id = fGA5
// module chunks = 1